import {Component, EventEmitter, Input, Output,} from '@angular/core';

// NOT_IN_USE_CURRENTLY
@Component({
    selector: 'mvs-wf-process-step-side-activity-object-create',
    templateUrl: './wf-process-step-side-activity-object-create.component.html',
    standalone: false
})
export class WfProcessStepSideActivityObjectCreateComponent {

    @Input() activity;
    @Output() onTabChange = new EventEmitter<any>();


}
